export const OnlineSvg = (props) => {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.22706 10.773C2.60025 10.1462 2.10305 9.40209 1.76382 8.58314C1.4246 7.76418 1.25 6.88643 1.25 6C1.25 5.11358 1.4246 4.23583 1.76382 3.41687C2.10305 2.59792 2.60025 1.8538 3.22706 1.22701M12.7731 1.22701C13.3999 1.8538 13.8971 2.59792 14.2363 3.41687C14.5755 4.23583 14.7501 5.11358 14.7501 6C14.7501 6.88643 14.5755 7.76418 14.2363 8.58314C13.8971 9.40209 13.3999 10.1462 12.7731 10.773M5.34806 8.65126C4.64504 7.94803 4.25011 6.99437 4.25011 6C4.25011 5.00564 4.64504 4.05198 5.34806 3.34876M10.6521 3.34876C11.3551 4.05198 11.75 5.00564 11.75 6C11.75 6.99437 11.3551 7.94803 10.6521 8.65126M8.75006 6C8.75006 6.19892 8.67104 6.38968 8.53039 6.53033C8.38974 6.67099 8.19897 6.75 8.00006 6.75C7.80115 6.75 7.61038 6.67099 7.46973 6.53033C7.32908 6.38968 7.25006 6.19892 7.25006 6C7.25006 5.80109 7.32908 5.61033 7.46973 5.46967C7.61038 5.32902 7.80115 5.25 8.00006 5.25C8.19897 5.25 8.38974 5.32902 8.53039 5.46967C8.67104 5.61033 8.75006 5.80109 8.75006 6Z"
        stroke="#24269F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
